import { m } from 'motion/react';
import { useState } from 'react';
import { containerVariants, itemVariants, viewPort } from '../../utils/framer';
import { trackEvent } from '../../utils/tracking';

type Props = {
  title: string;
  questions: { q: string; a: string }[];
  className?: string;
  titleAlign?: 'left' | 'center';
};

const FaqBlock = ({
  title,
  questions,
  className,
  titleAlign = 'center',
}: Props) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return (
    <m.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      className={`pt-8 pb-12 px-2 ${className ?? ''}`}
    >
      <m.h2
        variants={itemVariants}
        className={`
          px-4 mb-8 mt-6 pb-8
          ${titleAlign === 'left' ? 'text-left' : 'text-center'}
        `}
      >
        {title}
      </m.h2>
      <m.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        className="mx-auto max-w-screen-kia-sm px-4"
      >
        {questions.map((faq, index) => (
          <m.div
            variants={itemVariants}
            key={index}
            className="border-t border-gray-200"
          >
            <button
              onClick={() =>
                setActiveIndex(index === activeIndex ? null : index)
              }
              className="flex w-full gap-4 py-4 justify-between"
            >
              <h3 className="text-lg text-left font-bold">{faq.q}</h3>
              <svg
                viewBox="0 0 512 512"
                fill="#fff"
                height="1.5em"
                width="1.5em"
                className="flex-shrink-0"
              >
                <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={48}
                  d="M112 184l144 144 144-144"
                />
              </svg>
            </button>
            <p
              dangerouslySetInnerHTML={{ __html: faq.a }}
              onClick={(e) => {
                const target = e.target as HTMLElement;
                const anchor = target.closest('a');
                if (anchor?.href.includes('sok-aterforsaljare-verkstad')) {
                  trackEvent({ event: 'find_a_dealer', model: undefined });
                }
              }}
              className={`pr-4 pb-4 ${index !== activeIndex ? 'hidden' : ''}`}
            ></p>
          </m.div>
        ))}
      </m.div>
    </m.div>
  );
};

export default FaqBlock;
